"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _intFormatter = _interopRequireDefault(require("@sprinx/formatting/intFormatter"));

var _TextFormattedReplace = _interopRequireDefault(require("../TextFormattedReplace"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      textAlign: 'center'
    },
    inStore: {
      fontSize: 16,
      fontWeight: 300,
      color: theme.palette.secondary.main,
      fontStyle: 'italic'
    },
    quantity: {
      fontWeight: 500
    },
    soldout: (0, _defineProperty2.default)({
      fontSize: 16,
      fontStyle: 'italic',
      fontWeight: 300,
      color: theme.palette.primary.main
    }, theme.breakpoints.only('sm'), {
      display: 'flex',
      justifyContent: 'center'
    })
  };
}, {
  name: 'AvailabilityFieldPreview'
});

var _ref2 = /*#__PURE__*/_react.default.createElement("br", null);

var _ref3 = /*#__PURE__*/_react.default.createElement("br", null);

function AvailabilityFieldPreview(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      delInfo = _ref.delInfo,
      product = _ref.product,
      replaceBr = _ref.replaceBr,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "delInfo", "product", "replaceBr"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  var quantity = delInfo.quantity,
      showroom = delInfo.showroom,
      warehouse = delInfo.warehouse;

  var content = _react.default.useMemo(function () {
    var showroomDisplay = function showroomDisplay() {
      return showroom ? /*#__PURE__*/_react.default.createElement("span", {
        className: classes.inStore,
        style: {
          marginLeft: 8
        }
      }, t('productDetailPage/disponibility/showroom')) : null;
    };

    if (warehouse) {
      if (warehouse === '1' || warehouse === '2') {
        var translatePath = warehouse === '1' ? 'primary' : 'secondary';

        var _count = [50, 30, 10, 5].find(function (i) {
          return i <= quantity;
        });

        return _count ? /*#__PURE__*/_react.default.createElement("span", {
          className: classes.inStore
        }, /*#__PURE__*/_react.default.createElement(_TextFormattedReplace.default, {
          replaces: {
            br: function br() {
              return _ref2;
            },
            count: function count() {
              return /*#__PURE__*/_react.default.createElement("span", {
                className: classes.quantity
              }, (0, _intFormatter.default)(_count));
            }
          }
        }, t("productDetailPage/disponibility/".concat(translatePath, "MoreThan"), {
          br: replaceBr ? '##br##' : '',
          count: _count,
          countFormatted: '##count##'
        })), showroomDisplay()) : /*#__PURE__*/_react.default.createElement("span", {
          className: classes.inStore
        }, /*#__PURE__*/_react.default.createElement(_TextFormattedReplace.default, {
          replaces: {
            br: function br() {
              return _ref3;
            },
            count: function count() {
              return /*#__PURE__*/_react.default.createElement("span", {
                className: classes.quantity
              }, (0, _intFormatter.default)(_count));
            }
          }
        }, t("productDetailPage/disponibility/".concat(translatePath, "LessThan"), {
          br: replaceBr ? '##br##' : '',
          count: 5,
          countFormatted: '##count##'
        })), showroomDisplay());
      }

      if (warehouse === 'external') {
        return /*#__PURE__*/_react.default.createElement("span", {
          className: classes.inStore
        }, t('productDetailPage/disponibility/external'));
      }
    }

    return /*#__PURE__*/_react.default.createElement("span", {
      className: classes.soldout
    }, t('productDetailPage/disponibility/unavailable')); // return <span className={classes.soldout}>{t('productDetailPage/disponibility/soldout')}</span>;
  }, [classes, quantity, replaceBr, showroom, t, warehouse]);

  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), content);
}

process.env.NODE_ENV !== "production" ? AvailabilityFieldPreview.propTypes = {
  classes: _propTypes.default.shape({
    inStore: _propTypes.default.string,
    quantity: _propTypes.default.string,
    root: _propTypes.default.string,
    soldout: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  delInfo: _propTypes.default.shape({
    available: _propTypes.default.bool,
    quantity: _propTypes.default.number,
    showroom: _propTypes.default.bool,
    warehouse: _propTypes.default.string
  }),
  product: _propTypes.default.shape({
    taxonomies: _propTypes.default.arrayOf(_propTypes.default.string)
  }).isRequired,
  replaceBr: _propTypes.default.bool
} : void 0;
AvailabilityFieldPreview.defaultProps = {
  classes: undefined,
  className: undefined,
  delInfo: {
    available: false
  },
  replaceBr: false
};
var _default = AvailabilityFieldPreview;
exports.default = _default;